/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Component, TemplateRef, ViewChild } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { ButtonComponent } from "../../shared/components/button/button.component";
import { AuthorizationService } from "../../shared/services/authorization.service";
import { DialogService } from "../../shared/services/dialog.service";
import { PATHS } from "../../shared/utils/constants";
import { GRANTS } from "../../shared/utils/grants.constants";

@Component({
	selector: "globalictcc-toolbox",
	standalone: true,
	imports: [ButtonComponent, RouterOutlet],
	templateUrl: "./toolbox.component.html",
	styleUrl: "./toolbox.component.scss"
})
export class ToolboxComponent {
	public readonly grants = GRANTS.toolbox;
	public readonly authorizationService: AuthorizationService;

	@ViewChild("whatIf") public whatIfDialogContent: TemplateRef<unknown>;
	@ViewChild("calculator") public calculatorDialogContent: TemplateRef<unknown>;
	@ViewChild("anomaliesDetection") public anomaliesDetectionDialogContent: TemplateRef<unknown>;

	public paths = PATHS;

	constructor(
		private _router: Router,
		private _dialogService: DialogService,
		authorizationService: AuthorizationService
	) {
		this.authorizationService = authorizationService;
	}

	/**
	 * Handles the action when a user wants to read more about a specific tool.
	 * Opens a dialog with relevant information based on the tool selected.
	 *
	 * @param tool - The identifier of the tool for which more information is requested.
	 *               Possible values are "what-if", "calculator", or any other string for anomalies detection.
	 */
	public onToolReadMore(tool: string) {
		const dialogIcon =
			tool === "what-if" ? "sustainability" : tool === "calculator" ? "meter" : "junction";

		const dialogTitle =
			tool === "what-if"
				? "What if"
				: tool === "calculator"
					? "Calculator"
					: "Anomalies detection";

		const dialogContent =
			tool === "what-if"
				? this.whatIfDialogContent
				: tool === "calculator"
					? this.calculatorDialogContent
					: this.anomaliesDetectionDialogContent;

		this._dialogService.open({
			data: {
				type: "info",
				iconName: dialogIcon,
				isIconVisible: true,
				title: dialogTitle,
				content: dialogContent
			}
		});
	}

	/**
	 * Navigates to the specified tool's URL.
	 *
	 * @param tool - The URL of the tool to navigate to.
	 */
	public onToolSelected(tool: string) {
		this._router.navigateByUrl(tool);
	}
}
